export default "__VITE_ASSET__SIqJenA4__"